import { Animation, _, px } from '../../modules/scrollAnimation/Animation'

document.addEventListener('DOMContentLoaded', () => {
	const wrapper = document.querySelector('.scroll-wrapper')
	const scene = wrapper.querySelector('.scene')
	const animation = new Animation(wrapper, scene)

	const stepper = document.querySelector('.stepper')

	;[...document.querySelectorAll('.step')].forEach((step, key) => {
		step.addEventListener('click', () => animation.navigateTo('realization_' + (key + 1)))
	})

	animation
		// *****************************
		//           HANDLERS
		// *****************************
		.addProgressChangedHandler(progress => {
			const {x, y, width} = stepper.getBoundingClientRect()
			const element = document.elementFromPoint(x + width / 2, y - 10)
			const whiteBackground = !element || element.classList.contains('scene')

			if (whiteBackground) stepper.classList.add('stepper--color')
			else stepper.classList.remove('stepper--color')
		})
		// *****************************
		//            PLUGINS
		// *****************************
		.addPlugin('scale', (element, progress, data) => {
			let value

			if (Array.isArray(data)) {
				const [from, to] = data
				value = (to - from) * progress + from
			} else value = data

			element.style.transform = `scale(${value})`
			if (value >= 1.2) element.parentElement.classList.add('active')
			else element.parentElement.classList.remove('active')
		})
		// *****************************
		//           ELEMENTY
		// *****************************
		// zdjęcia
		.addElement('.img-1', 'img1')
		.addElement('.img-2', 'img2')
		.addElement('.img-3', 'img3')
		// loga
		.addElement('.logo-1', 'logo1')
		.addElement('.logo-2', 'logo2')
		.addElement('.logo-3', 'logo3')
		// opisy
		.addElement('.description-1', 'desc1')
		.addElement('.description-2', 'desc2')
		.addElement('.description-3', 'desc3')
		// stepper
		.addElement('.step_point--1', 'step1', { displayAlways: true })
		.addElement('.step_point--2', 'step2', { displayAlways: true })
		.addElement('.step_point--3', 'step3', { displayAlways: true })
		// *****************************
		//           ANIMACJE
		// *****************************
		// S1 Odsunięcie loga w prawo i opisu do góry
		.addFrame(0, {
			logo1: {
				right: 0
			},
			img1: {},
			desc1: {
				right: '52%',
				left: '15%',
				bottom: 0,
				top: 0
			},
			step1: {
				opacity: 1,
				scale: 1.3
			}
		}, 'realization_1')
		.addFrame(10, {
			logo1: {
				right: [_, -400, px]
			},
			img1: {},
			desc1: {
				right: '52%',
				left: '15%',
				bottom: [_, 100, '%'],
				top: [_, -100, '%']
			},
			step1: {
				opacity: 1,
				scale: 1.3
			}
		})
		// S1 -> S2
		.addFrame(10, {
			img1: {},
			img2: {
				opacity: [0, 1]
			},
			step1: {
				opacity: [_, 0.4],
				scale: [1.3, 1]
			},
			step2: {
				opacity: [0.4, 1],
				scale: [1, 1.3]
			}
		})
		// S2 Wjazd treśści
		.addFrame(10, {
			img2: {},
			desc2: {
				left: '52%',
				right: '15%',
				bottom: [-100, 0, '%'],
				top: [100, 0, '%']
			},
			logo2: {
				left: [-400, 0, px]
			},
			step2: {
				scale: 1.3
			}
		}, 'realization_2')
		// S2 Odsunięcie loga w lewo i opisu do góry
		.addFrame(10, {
			logo2: {
				left: [_, -400, px]
			},
			img2: {},
			desc2: {
				bottom: [_, 100, '%'],
				top: [_, -100, '%']
			},
			step2: {
				opacity: 1,
				scale: 1.3
			}
		})
		// S2 -> S3
		.addFrame(10, {
			img2: {},
			img3: {
				opacity: [0, 1]
			},
			step2: {
				opacity: [_, 0.4],
				scale: [1.3, 1]
			},
			step3: {
				opacity: [0.4, 1],
				scale: [1, 1.3]
			}
		})
		.addFrame(10, {
			img3: {},
			desc3: {
				right: '52%',
				left: '12%',
				bottom: [-100, 0, '%'],
				top: [100, 0, '%']
			},
			logo3: {
				right: [-400, 0, px]
			},
			step3: {
				scale: 1.3
			}
		}, 'realization_3')
		.init()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/horizontal-slider/script.js